import { ReactNode } from "react";

import { CloseIcon } from "@/assets/icons";
import Tooltip from "@/components/ui/tooltip";

type Props = {
  title: string;
  children?: ReactNode;
  onClose: () => void;
  /** Drops the close button only. `children` still render, so a panel whose
   * header action is something other than closing (e.g. minimize) keeps its
   * action group. */
  withCloseButton?: boolean;
};

const SpatialHeader = ({
  title,
  children,
  onClose,
  withCloseButton = true
}: Props) => {
  return (
    <div className="flex flex-col px-4 mt-4">
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-txtHeading font-sans font-bold text-[20px]">
          {title}
        </h2>
        {(withCloseButton || children) && (
          <div className="flex gap-3">
            {children}
            {withCloseButton && (
              <Tooltip content="Close" position="bottom-center">
                <button
                  type="button"
                  className="bg-transparent border-0 p-0 cursor-pointer"
                  onClick={onClose}
                  aria-label="Close"
                  data-testid="btn-header-close"
                >
                  <CloseIcon className="fill-dim-gray" />
                </button>
              </Tooltip>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SpatialHeader;
